<template>
  <a-drawer
    ref="productComparison"
    title="配方 VS 产品"
    placement="right"
    :visible="hidden"
    @close="onClose"
    width="900"
    destroyOnClose
  >
    <a-tabs v-model="tabKey">
      <a-tab-pane tab="原料" key="productDrawer" :forceRender="true">
        <product-drawer ref="productDrawer" :hidden="hidden" :tabKey="tabKey" :y="curHeight" :diff="diff" @checkLoadling="checkLoadling" :loading="loading" />
      </a-tab-pane>
      <a-tab-pane tab="营养需要量" key="nutirtionDrawer" :forceRender="true">
        <NutirtionDrawer ref="nutirtionDrawer" :hidden="hidden" :tabKey="tabKey" :y="curHeight" :diff="diff" @checkLoadling="checkLoadling" :loading="loading" />
      </a-tab-pane>
      <a-space slot="tabBarExtraContent">
        <a-checkbox v-model="diff" class="icon-bar" :disabled="loading">
          仅展示有差异项
        </a-checkbox>
        <a @click="downloadExcel" style="cursor: pointer;color: #1890ff" :disabled="loading">
          <a-icon type="download" />
          下载报表
        </a>
      </a-space>
    </a-tabs>
  </a-drawer>
</template>
<script>
import ProductDrawer from './ProductDrawer.vue';
import NutirtionDrawer from './NutirtionDrawer.vue'
import { exportExcel } from "@/Utils/excel/Export2Excel";
import { nhfMixins } from '../../untils'
import moment from 'moment'
export default {
  components:{ProductDrawer,NutirtionDrawer},
  props: ['hidden','productPrice'],
  mixins: [nhfMixins],
  data(){
    return {
      tabKey: 'productDrawer',
      curHeight: 500,
      diff: true,
      loadingNum: 0
    }
  },
  computed:{
    loading(){
      return this.loadingNum < 2
    }
  },
  beforeMount(height) {
    var h = document.documentElement.clientHeight || document.body.clientHeight;
    this.curHeight = h - (height || 0) - 180; 
  },
  watch: {
    hidden(val){
      if(val) {
        this.tabKey = 'productDrawer'
        this.getActiveProduct(this.detail.formulaCode)
        this.loadingNum = 0
      }
    }
  },
  methods: {
    checkLoadling(){
      this.loadingNum++
    },
    onClose(){
      this.diff = true
      this.$emit('cancel');
    },
    getHeadData(){
      // let factoryName = window.localStorage.getItem('factoryName')
      let formulaName = this.detail.formulaName
      let productName = this.detailProductName
      let currentDate = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
      return [
        // ['工厂名称',factoryName,factoryName],
        ['类型','配方模型','激活版本产品'],
        ['配方名称',formulaName,productName],
        ['对比日期',currentDate,currentDate],
      ]
    },
    getFormulaData(){
      let {price} = this.detail || {}
      let {price: productPrice} = this.productPrice || {}
      let len = 3
      let a = 0
      let b = 0
      let c = (Number(price || 0) - Number(productPrice || 0)).toFixed(len)
      if(price || price === 0) a = price || price === 0 ? Number(price).toFixed(len) : a.toFixed(len)
      if(productPrice || productPrice === 0) b = productPrice || productPrice === 0 ? Number(productPrice).toFixed(len) : b.toFixed(len)
      return [
        '配方成本','','',a,b,c
      ]
    },
    async downloadExcel(){
      let factoryName = window.localStorage.getItem('factoryName')
      let productDrawer = await this.$refs.productDrawer.downloadExcel()
      let nutirtionDrawer = await this.$refs.nutirtionDrawer.downloadExcel()
      let {tHeader:productDrawertHeader,data: productDrawerData,tTitle} = productDrawer || {}
      let {tHeader:nutirtionDrawerHeader,data: nutirtionDrawerData} = nutirtionDrawer || {}
      let detailData = this.getHeadData()
      let formulaData = this.getFormulaData()
      let data = [
        ...detailData,
        productDrawertHeader,
        ...productDrawerData,
        formulaData,
        nutirtionDrawerHeader,
        ...nutirtionDrawerData
      ]
      exportExcel(['工厂名称',factoryName,factoryName], data, tTitle)
    },
    async getActiveProduct(formulaCode){
      let res = await this.fetchPost({
        actions: this.getCustomProPageByCond,
        isList: true,
        data: {
          query: {size: 100,current: 1},status:0,isActivate: 1,formulaCode,
          factoryId: window.localStorage.getItem('factoryId'),
        },
      });
      let {records} = res || {}
      this.detailProductName = records && records[0] ? records[0].productName : ''
    }
  }
}
</script>
